import { Routes, RouterModule } from '@angular/router';

import { CharityFormsScreenComponent } from './charity-forms.component';

const charityFormsRoutes: Routes = [];

export const CharityFormsRouter = RouterModule.forChild(charityFormsRoutes);